(function () {
  'use strict';
  if (window.MNL_FORMULA_LIBRARY) return;
  var ENDPOINT = '/apps/mnl-formulas';
  var PRODUCT = 'https://www.mynutrilab.com/products/pre-workout-mynutrilab-personnalisable-au-mg-pres';
  var UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
  var messages = {
    loading: 'Chargement de ta bibliothèque…', refresh: 'Actualiser',
    empty: 'Aucune formule enregistrée dans ton compte pour le moment.', open: 'Ouvrir cette formule',
    delete: 'Supprimer', delete_question: 'Supprimer cette formule de ton compte ?',
    delete_confirm: 'Confirmer la suppression', cancel: 'Annuler',
    saved: 'Formule enregistrée dans ton compte.', deleted: 'Formule supprimée de ton compte.',
    saving: 'Enregistrement en cours…', checking: 'Vérification de l’enregistrement…',
    guest: 'Connecte-toi, puis clique à nouveau sur Enregistrer. Rien ne sera sauvegardé automatiquement.',
    login: 'Se connecter', load_error: 'Bibliothèque indisponible. Réessaie pour vérifier tes formules.',
    invalid: 'Ce nom ou ce lien de formule est invalide. Aucun enregistrement envoyé.',
    conflict: 'Ta bibliothèque a changé. Actualise-la, puis confirme à nouveau ton action.',
    unknown: 'Résultat non confirmé. Vérifie l’enregistrement avant de réessayer ou de recharger cette page.',
    check: 'Vérifier l’enregistrement', retry_write: 'Réessayer la même action',
    not_found: 'Aucun reçu trouvé pour le moment. Une requête peut encore aboutir. Vérifie à nouveau ou réessaie la même action.',
    pending: 'Une action attend encore une vérification. Termine-la avant d’en commencer une autre.',
    full: 'Ta bibliothèque contient déjà 50 formules. Supprime une formule avant d’en ajouter une.',
    added_on: 'Ajoutée le', unavailable: 'La sauvegarde est momentanément indisponible. Réessaie plus tard.'
  };
  var snapshot = null, trusted = false, busy = false, busyId = 0, pending = null, pendingOwner = null, pendingUncertain = false, generation = 0;
  var panels = [], saveButtons = new Set(), actionStatus = null;
  var mounted = new WeakSet(), watched = new WeakSet();
  function t(key) {
    var copy = document.querySelector('[data-mnl-library-copy]');
    if (copy) {
      try {
        var translated = JSON.parse(copy.textContent);
        if (typeof translated[key] === 'string' && translated[key]) return translated[key];
      } catch (_) {}
    }
    return typeof window.MNL_T === 'function' ? window.MNL_T('library.' + key, messages[key] || key) : messages[key] || key;
  }
  function node(tag, text, className) {
    var el = document.createElement(tag);
    if (text !== undefined) el.textContent = text;
    if (className) el.className = className;
    return el;
  }
  function button(text, handler) {
    var el = node('button', text, 'mnl-library__button');
    el.type = 'button'; el.addEventListener('click', handler); return el;
  }
  function normalizeName(value) {
    if (typeof value !== 'string' || /[\u0000-\u001f\u007f-\u009f]/.test(value)) return '';
    for (var i = 0; i < value.length; i++) {
      var c = value.charCodeAt(i);
      if (c >= 0xd800 && c <= 0xdbff) {
        var next = value.charCodeAt(++i);
        if (!(next >= 0xdc00 && next <= 0xdfff)) return '';
      } else if (c >= 0xdc00 && c <= 0xdfff) return '';
    }
    var name = value.normalize('NFC').trim();
    return Array.from(name).length <= 50 ? name : '';
  }
  function params(raw, plus) {
    var out = new Map();
    if (!raw) return out;
    raw.split('&').forEach(function (part) {
      if (!part) throw Error('parameters');
      var pos = part.indexOf('='), decode = function (v) { return decodeURIComponent(plus ? v.replace(/\+/g, ' ') : v); };
      var k = decode(pos < 0 ? part : part.slice(0, pos)), v = decode(pos < 0 ? '' : part.slice(pos + 1));
      if (!k || out.has(k) || /[\u0000-\u001f\u007f-\u009f]/.test(k + v)) throw Error('parameters');
      out.set(k, v);
    });
    return out;
  }
  function canonical(value, name) {
    try {
      if (typeof value !== 'string' || value.length > 8192 || !name || /[\u0000-\u0020\u007f-\u009f\\]/.test(value)) return null;
      var url = new URL(value), path = new URL(PRODUCT).pathname;
      if (url.protocol !== 'https:' || url.username || url.password || url.port ||
          !['www.mynutrilab.com', 'mynutrilab.com'].includes(url.hostname) || ![path, path + '/'].includes(url.pathname)) return null;
      var q = params(url.search.slice(1), true), hash = params(url.hash.slice(1), false);
      if (Array.from(q.keys()).some(function (key) { return !['r', 'f', 'step', 'label'].includes(key) && !/^utm_[a-z_]{1,30}$/.test(key); }) ||
          Array.from(hash).some(function (entry) { return entry[0] !== 'nm' || !normalizeName(entry[1]); }) || q.has('r') === q.has('f')) return null;
      var type = q.has('r') ? 'r' : 'f', code = q.get(type), label = q.get('label');
      if (type === 'r' ? !/^\d{16,18}$/.test(code) : !/^[A-Za-z0-9_-]{1,6000}$/.test(code) || code.length % 4 === 1) return null;
      if (label !== undefined && !['standard', 'halloween', 'gta', 'neon'].includes(label)) return null;
      return PRODUCT + '?' + type + '=' + code + '&step=2' + (label !== undefined ? '&label=' + label : '') + '#nm=' + encodeURIComponent(name);
    } catch (_) { return null; }
  }
  function validVersion(v) { return Number.isSafeInteger(v) && v >= 0 && v < Number.MAX_SAFE_INTEGER; }
  function validSnapshot(value) {
    if (!value || value.ok !== true || !/^[0-9a-f]{64}$/.test(value.owner || '') || !validVersion(value.version) || typeof value.csrfToken !== 'string' ||
        !/^[A-Za-z0-9_-]+\.[A-Za-z0-9_-]+$/.test(value.csrfToken) || value.csrfToken.length > 1024 ||
        !Array.isArray(value.items) || value.items.length > 50) return false;
    var ids = new Set(), urls = new Set();
    return value.items.every(function (item) {
      if (!item || !UUID.test(item.id || '') || ids.has(item.id) || urls.has(item.url) ||
          !item.name || normalizeName(item.name) !== item.name || canonical(item.url, item.name) !== item.url ||
          typeof item.createdAt !== 'string' || !/^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d\.\d{3}Z$/.test(item.createdAt) ||
          !Number.isFinite(Date.parse(item.createdAt)) || new Date(item.createdAt).toISOString() !== item.createdAt) return false;
      ids.add(item.id); urls.add(item.url); return true;
    });
  }
  function proof(value, intent) {
    var op = value && value.operation;
    return !!(op && intent && op.id === intent.operationId && op.status === 'applied' && op.action === intent.action &&
      UUID.test(op.itemId || '') && op.version === intent.version + 1 && value.version >= op.version &&
      (intent.action === 'save' ? op.name === intent.name && op.url === intent.url : op.itemId === intent.id) &&
      (value.version !== op.version || (intent.action === 'save'
        ? value.items.some(function (item) { return item.id === op.itemId && item.name === intent.name && item.url === intent.url; })
        : !value.items.some(function (item) { return item.id === intent.id; }))));
  }
  function targets(status) {
    return Array.from(new Set(panels.map(function (p) { return p.querySelector('[data-mnl-library-status]'); }).concat(status || actionStatus).filter(Boolean)));
  }
  function say(key, status, controls) {
    targets(status).forEach(function (el) {
      el.replaceChildren(node('p', t(key))); el.setAttribute('role', 'status'); el.setAttribute('aria-live', 'polite');
      if (controls) controls(el);
    });
  }
  function visible(panel) {
    return !panel.closest('[hidden]') && window.getComputedStyle(panel).display !== 'none';
  }
  function syncControls() {
    saveButtons.forEach(function (b) { b.disabled = busy || !!pending; b.setAttribute('aria-busy', busy ? 'true' : 'false'); });
    panels.forEach(function (p) {
      p.setAttribute('aria-busy', busy ? 'true' : 'false');
      p.querySelectorAll('[data-mnl-library-delete], [data-mnl-library-export]').forEach(function (b) { b.disabled = busy || !!pending || !trusted; });
      p.querySelectorAll('[data-mnl-library-refresh]').forEach(function (b) { b.disabled = busy; });
    });
  }
  function hideData() {
    snapshot = null; trusted = false;
    panels.forEach(function (p) { p.querySelector('[data-mnl-library-list]').replaceChildren(); });
  }
  function login(status) {
    hideData(); pending = null; pendingOwner = null; pendingUncertain = false; generation++;
    say('guest', status, function (el) {
      var returnTo = window.location.pathname + window.location.search + window.location.hash;
      if (!/^\/(?!\/)/.test(returnTo) || /[\u0000-\u0020\u007f\\]/.test(returnTo) || returnTo.length > 8192) returnTo = '/account';
      var link = node('a', t('login'), 'mnl-library__button');
      link.href = '/customer_authentication/login?return_to=' + encodeURIComponent(returnTo); el.appendChild(link);
    });
    syncControls();
  }
  async function request(method, body, operationId) {
    var controller = new AbortController(), timeout;
    var deadline = new Promise(function (_, reject) {
      timeout = window.setTimeout(function () { controller.abort(); reject(Error('timeout')); }, 20000);
    });
    try {
      return await Promise.race([deadline, (async function () {
        var response = await window.fetch(ENDPOINT + (operationId ? '?operationId=' + encodeURIComponent(operationId) : ''), {
          method: method, credentials: 'same-origin', cache: 'no-store', redirect: 'error', signal: controller.signal,
          headers: { Accept: 'application/json', ...(body ? { 'Content-Type': 'application/json' } : {}) },
          ...(body ? { body: JSON.stringify(body) } : {})
        });
        var data;
        try { data = await response.json(); } catch (_) { data = null; }
        return { status: response.status, data: data };
      })()]);
    } finally { window.clearTimeout(timeout); }
  }
  function accept(data) { snapshot = data; trusted = true; render(); }
  function showUncertain(key) {
    if (!pending) return;
    pendingUncertain = true;
    hideData();
    say(key || 'unknown', null, function (el) {
      var group = node('div', undefined, 'mnl-library__actions');
      var check = button(t('check'), function () { reconcile(false); }); check.dataset.mnlLibraryCheck = '';
      var retry = button(t('retry_write'), function () { reconcile(true); }); retry.dataset.mnlLibraryRetry = '';
      check.disabled = retry.disabled = busy; group.append(check, retry); el.appendChild(group);
    });
    syncControls();
  }
  function finish(data, intent) {
    pending = null; pendingOwner = null; pendingUncertain = false; accept(data); say(intent.action === 'save' ? 'saved' : 'deleted');
    if (intent.action === 'delete' && actionStatus && actionStatus.isConnected) {
      actionStatus.setAttribute('tabindex', '-1'); actionStatus.focus();
    }
  }
  function changedOwner() {
    pending = null; pendingOwner = null; pendingUncertain = false; hideData();
    say('conflict', null, function (el) { el.appendChild(button(t('refresh'), refresh)); });
  }
  async function send(intent, csrf) {
    var stamp = generation;
    try {
      var result = await request('POST', Object.assign({}, intent, { csrfToken: csrf }));
      if (stamp !== generation) return { ok: false, status: 'stale' };
      if (result.status === 401) { login(); return { ok: false, status: 'guest' }; }
      if (result.status === 200 && validSnapshot(result.data) && result.data.owner !== pendingOwner) {
        changedOwner(); return { ok: false, status: 'conflict' };
      }
      if (result.status === 200 && validSnapshot(result.data) && proof(result.data, intent)) {
        finish(result.data, intent); return { ok: true, status: 'saved' };
      }
      if (result.status >= 400 && result.status < 500 && result.data && result.data.ok === false) {
        if (pendingUncertain) { showUncertain(); return { ok: false, status: 'unknown' }; }
        pending = null; pendingOwner = null; hideData();
        var key = result.data.error === 'library_full' ? 'full' : result.status === 409 ? 'conflict' : 'unavailable';
        say(key, null, function (el) { el.appendChild(button(t('refresh'), function () { refresh(); })); });
        return { ok: false, status: key };
      }
    } catch (_) { if (stamp !== generation) return { ok: false, status: 'stale' }; }
    showUncertain(); return { ok: false, status: 'unknown' };
  }
  async function begin(input, trigger, status) {
    if (busy || pending) { if (pending) showUncertain('pending'); return { ok: false, status: 'pending' }; }
    actionStatus = status || null;
    if (trigger) saveButtons.add(trigger);
    busy = true; hideData(); syncControls(); say('saving');
    var stamp = ++generation, run = ++busyId;
    try {
      var result = await request('GET');
      if (stamp !== generation) return { ok: false, status: 'stale' };
      if (result.status === 401) { login(); return { ok: false, status: 'guest' }; }
      if (result.status !== 200 || !validSnapshot(result.data)) throw Error('read');
      accept(result.data);
      if (input.action === 'save' && snapshot.items.length >= 50 && !snapshot.items.some(function (item) { return item.url === input.url; })) {
        say('full'); return { ok: false, status: 'full' };
      }
      if (input.action === 'delete' && !snapshot.items.some(function (item) { return item.id === input.id; })) {
        say('conflict'); return { ok: false, status: 'conflict' };
      }
      if (!window.crypto || typeof window.crypto.randomUUID !== 'function') throw Error('crypto');
      pending = Object.assign({}, input, { version: snapshot.version, operationId: window.crypto.randomUUID() });
      pendingOwner = snapshot.owner;
      pendingUncertain = false;
      return await send(pending, snapshot.csrfToken);
    } catch (_) { if (stamp === generation) say('load_error'); return { ok: false, status: 'error' }; }
    finally { if (run === busyId) { busy = false; if (pending) showUncertain(); syncControls(); } }
  }
  async function save(url, name, trigger, status) {
    var normalized = normalizeName(name), safe = canonical(url, normalized);
    if (!safe) { say('invalid', status); return { ok: false, status: 'invalid' }; }
    return begin({ action: 'save', name: normalized, url: safe }, trigger, status);
  }
  async function reconcile(retry) {
    if (busy || !pending) return;
    busy = true; syncControls(); say('checking');
    var intent = pending, stamp = ++generation, run = ++busyId, message = 'unknown';
    try {
      var result = await request('GET', null, intent.operationId);
      if (stamp !== generation) return;
      if (result.status === 401) { login(); return; }
      if (result.status !== 200 || !validSnapshot(result.data)) throw Error('read');
      if (result.data.owner !== pendingOwner) { changedOwner(); return; }
      if (proof(result.data, intent)) { finish(result.data, intent); return; }
      var op = result.data.operation;
      if (!op || op.id !== intent.operationId || op.status !== 'not_found') throw Error('proof');
      snapshot = result.data; trusted = false;
      message = 'not_found';
      if (retry) await send(intent, result.data.csrfToken);
    } catch (_) {}
    finally { if (run === busyId) { busy = false; if (pending) showUncertain(message); syncControls(); } }
  }
  async function refresh() {
    if (busy) return;
    if (pending) { showUncertain(); return; }
    var stamp = ++generation; hideData(); syncControls(); say('loading');
    try {
      var result = await request('GET');
      if (stamp !== generation) return;
      if (result.status === 401) { login(); return; }
      if (result.status !== 200 || !validSnapshot(result.data)) throw Error('read');
      accept(result.data); targets().forEach(function (el) { el.replaceChildren(); });
    } catch (_) { if (stamp === generation) say('load_error', null, function (el) { el.appendChild(button(t('refresh'), refresh)); }); }
    finally { if (stamp === generation) syncControls(); }
  }
  function confirmDelete(item, card, trigger) {
    if (busy || pending || !trusted || card.querySelector('[data-mnl-library-confirm]')) return;
    var group = node('div', undefined, 'mnl-library__confirmation'); group.dataset.mnlLibraryConfirm = '';
    group.setAttribute('role', 'group'); group.setAttribute('aria-label', t('delete_question'));
    group.appendChild(node('p', t('delete_question')));
    var cancel = button(t('cancel'), function () { group.remove(); trigger.hidden = false; trigger.focus(); });
    var confirm = button(t('delete_confirm'), function () {
      if (!trusted || busy || pending) return;
      begin({ action: 'delete', id: item.id }, confirm, card.closest('[data-mnl-library-panel]').querySelector('[data-mnl-library-status]'));
    });
    group.append(cancel, confirm); card.appendChild(group); trigger.hidden = true; cancel.focus();
  }
  function render() {
    panels.forEach(function (panel) {
      var list = panel.querySelector('[data-mnl-library-list]'); list.replaceChildren();
      if (!snapshot) return;
      if (!snapshot.items.length) { list.appendChild(node('p', t('empty'), 'mnl-library__note')); return; }
      snapshot.items.forEach(function (item) {
        var card = node('article', undefined, 'mnl-library__card');
        card.appendChild(node('h3', item.name));
        var date = node('time', t('added_on') + ' ' + new Date(item.createdAt).toLocaleDateString(document.documentElement.lang || 'fr'));
        date.dateTime = item.createdAt; card.appendChild(date);
        var actions = node('div', undefined, 'mnl-library__actions'), link = node('a', t('open'), 'mnl-library__button');
        link.href = item.url;
        var remove = button(t('delete'), function () { confirmDelete(item, card, remove); });
        remove.dataset.mnlLibraryDelete = ''; actions.append(link, remove); card.appendChild(actions); list.appendChild(card);
      });
    });
    syncControls();
  }
  function exportItems() {
    if (!trusted || !snapshot || busy || pending) return;
    var blob = new Blob([JSON.stringify({ format: 'mnl-formulas-v1', exportedAt: new Date().toISOString(), items: snapshot.items }, null, 2)], { type: 'application/json' });
    var url = URL.createObjectURL(blob), link = node('a');
    link.href = url; link.download = 'mynutrilab-formules.json'; document.body.appendChild(link); link.click(); link.remove();
    window.setTimeout(function () { URL.revokeObjectURL(url); }, 1000);
  }
  function mount(root) {
    (root || document).querySelectorAll('[data-mnl-library-save]').forEach(function (b) {
      if (mounted.has(b)) return; mounted.add(b); saveButtons.add(b);
      b.addEventListener('click', function () {
        var status = document.getElementById(b.getAttribute('data-mnl-library-status-id'));
        save(b.getAttribute('data-mnl-library-url'), b.getAttribute('data-mnl-library-name'), b, status);
      });
    });
    (root || document).querySelectorAll('[data-mnl-library-panel]').forEach(function (panel) {
      if (mounted.has(panel)) return; mounted.add(panel); panels.push(panel);
      panel.querySelector('[data-mnl-library-refresh]').addEventListener('click', refresh);
      var exportButton = panel.querySelector('[data-mnl-library-export]');
      if (exportButton) exportButton.addEventListener('click', exportItems);
      var tab = panel.closest('[data-panel="formulas"]') || panel, wasVisible = visible(panel);
      if (!watched.has(tab)) {
        watched.add(tab);
        new MutationObserver(function () {
          var nowVisible = visible(panel);
          if (nowVisible && !wasVisible && !busy && !pending) refresh();
          wasVisible = nowVisible;
        }).observe(tab, { attributes: true, attributeFilter: ['hidden', 'class', 'style'] });
      }
      if (wasVisible) refresh();
    });
    syncControls();
  }
  window.addEventListener('focus', function () { if (!busy && !pending && panels.some(visible)) refresh(); });
  window.addEventListener('hashchange', function () { if (!busy && !pending && panels.some(visible)) refresh(); });
  window.addEventListener('pagehide', function () {
    generation++; busyId++; busy = false; hideData(); pending = null; pendingOwner = null; pendingUncertain = false; actionStatus = null; syncControls();
  });
  window.addEventListener('pageshow', function (event) { if (event.persisted && panels.some(visible)) refresh(); });
  window.MNL_FORMULA_LIBRARY = Object.freeze({ save: save, mount: mount, refresh: refresh });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { mount(document); }, { once: true });
  else mount(document);
})();
